export default "__VITE_ASSET__C0h6gxjc__"